import { useAccount, useMsal } from "@azure/msal-react";
import { AppBar, Box, Grid, Toolbar, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";

const Header: FC = () => {
  const companyName = "Arena";
  const appName = "Content Lookup Tool";
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [name, setName] = useState("");

  useEffect(() => {
    let accountName = account?.name ?? "";
    setName(accountName);
  }, [account]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Grid container alignItems={"center"}>
            <Grid item xs={12} lg={6} textAlign={{xs: "center", lg: "start"}}>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {companyName.toUpperCase()}│{appName}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={6} textAlign={{xs: "center", lg: "end"}}>
              <Typography fontSize={{ lg: 16, xs: 11 }}>{name}</Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
